function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.48 6.65a.65.65 0 01.6-.71h18.66L21 1.55a.62.62 0 01-.19-.46.67.67 0 01.66-.66.65.65 0 01.43.15l6.48 6.02-6.45 6h-.07a.8.8 0 01-.43.17.66.66 0 01-.47-.19.68.68 0 010-1l4.77-4.43H7.08a.61.61 0 01-.6-.5zm15 10.35a.68.68 0 00-.67.67.57.57 0 00.19.45l.05.05 4.71 4.38H7.11a.66.66 0 000 1.32h18.65L21 28.25a.65.65 0 000 .94.67.67 0 00.48.2.73.73 0 00.43-.17h.06l6.45-6-6.51-6.12a2 2 0 00-.43-.1zm-5.62-1.54L12 19a.62.62 0 10.86.9l5.51-5.12-5.46-5.08a.62.62 0 00-.86.9l3.85 3.6H2.16a.62.62 0 000 1.24h13.7z"
})));